import s from './BackgroundImage.module.css';

export const BackgroundImage = (): JSX.Element => {
  return <div className={s.backgroundImage} />;
};
